import { createContext, useContext, type ReactNode } from 'react';
import type { BrandConfig } from './types';

const BrandContext = createContext<BrandConfig | null>(null);

export function BrandProvider({ config, children }: { config: BrandConfig; children: ReactNode }) {
  return <BrandContext.Provider value={config}>{children}</BrandContext.Provider>;
}

export function useBrand(): BrandConfig {
  const ctx = useContext(BrandContext);
  if (!ctx) throw new Error('useBrand must be used within a BrandProvider');
  return ctx;
}

/**
 * #119 tier 3 — shorthand accessor for the brand's product-copy
 * vocabulary. Equivalent to `useBrand().strings` but reads cleaner
 * at the call site when only strings are needed.
 *
 *   const strings = useBrandStrings();
 *   <h1>{strings.libraryTitle}</h1>
 */
export function useBrandStrings(): BrandConfig['strings'] {
  return useBrand().strings;
}
